export default class PlanAreaInfo {
        public yukaMenseki: number[];

        public koujiMenseki: number[];

        public genkanhoko: number;

        public maguchi: number;

        public roomCount: number;

        public roomType: string;

        public okuyuki: number;

        constructor() {
          this.yukaMenseki = [0.0, 0.0, 0.0, 0.0];
          this.koujiMenseki = [0.0, 0.0, 0.0, 0.0];
          this.roomCount = 0;
          this.genkanhoko = 0;
          this.maguchi = 0;
          this.okuyuki = 0;
        }
}
